import { logoutProcess } from './authHelper';

export const getApiHeader = () => {
    if (Date.now() <= parseInt(localStorage.getItem('time_expired'))) {
        localStorage.setItem('time_expired', (Date.now() + parseInt(process.env.REACT_APP_TIME_OUT_CLIENT)).toString());
        return getApiHeaderNotTime();
    }
    // logout
    logoutProcess();
    return {
        'content-type': 'application/json',
        Authorization: null,
    }
}

export const getApiHeaderNotTime = () => {
    return {
        'content-type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
    };
};


// WEBPACK FOOTER //
// ./src/services/getApiHeaders.js